// Storage utility for workout settings
// Key for storing pacing speeds
const PACING_SPEEDS_KEY = 'workout_pacing_speeds'
// Interface for stored pacing speeds
interface PacingSpeeds {
  [exerciseId: number]: number
}
// Get saved pacing speeds for all exercises
export const getSavedPacingSpeeds = (): PacingSpeeds => {
  try {
    const savedData = localStorage.getItem(PACING_SPEEDS_KEY)
    return savedData ? JSON.parse(savedData) : {}
  } catch (error) {
    console.error('Error retrieving pacing speeds:', error)
    return {}
  }
}
// Get saved pacing speed for a specific exercise
export const getSavedPacingSpeed = (
  exerciseId: number,
  defaultSpeed: number,
): number => {
  try {
    const speeds = getSavedPacingSpeeds()
    return speeds[exerciseId] !== undefined ? speeds[exerciseId] : defaultSpeed
  } catch (error) {
    console.error('Error retrieving pacing speed for exercise:', error)
    return defaultSpeed
  }
}
// Save pacing speed for a specific exercise
export const savePacingSpeed = (exerciseId: number, speed: number): void => {
  try {
    const speeds = getSavedPacingSpeeds()
    speeds[exerciseId] = speed
    localStorage.setItem(PACING_SPEEDS_KEY, JSON.stringify(speeds))
  } catch (error) {
    console.error('Error saving pacing speed:', error)
  }
}
// Reset all saved pacing speeds
export const resetAllPacingSpeeds = (): void => {
  try {
    localStorage.removeItem(PACING_SPEEDS_KEY)
  } catch (error) {
    console.error('Error resetting pacing speeds:', error)
  }
}
